import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    itemType: String,
  }

  rememberList(event) {
    const card = event.target.closest(".kanban-card")
    if (!card || !this.element.contains(card)) return

    const references = this.referencesForCardColumn(card)
    if (references.length === 0) return

    localStorage.setItem(this.storageKey, JSON.stringify(references))
    // Remember the list URL (with its current search/filters) so the detail
    // header's "back to list" button can return to this card view.
    try {
      localStorage.setItem(this.listUrlKey, window.location.href)
    } catch (error) {
      console.error("Error storing list URL in local storage:", error)
    }
  }

  referencesForCardColumn(card) {
    const column = card.closest("[data-board-triage-list]")
    if (!column) return []

    return Array.from(column.querySelectorAll(".kanban-card[data-reference]"))
      .map((columnCard) => columnCard.dataset.reference)
      .filter(Boolean)
  }

  get storageKey() {
    return this.itemTypeValue === "tasks" ? "paperworkTaskReferences" : "paperworkProcessReferences"
  }

  get listUrlKey() {
    return this.itemTypeValue === "tasks" ? "paperworkTaskListUrl" : "paperworkProcessListUrl"
  }
}
